import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Resume.css";

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          {/* <div className="heading-bullet"></div> */}
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div className="heading-date">
              {props.fromDate + "-" + props.toDate}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };

  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "Education", logoSrc: "education.svg" },
    { label: "Work History", logoSrc: "work-history.svg" },
    { label: "Programming Skills", logoSrc: "programming-skills.svg" },
    { label: "Projects", logoSrc: "projects.svg" },
    { label: "Interests", logoSrc: "interests.svg" },
  ];

  //here we have
  const programmingSkillsDetails = [
    { skill: "JavaScript", ratingPercentage: 85 },
    { skill: "React JS", ratingPercentage: 90 },
    { skill: "Express JS", ratingPercentage: 90 },
    { skill: "Node JS", ratingPercentage: 90 },
    { skill: "Mongo Db", ratingPercentage: 70 },
    { skill: "Angular", ratingPercentage: 80 },
    { skill: "HTML", ratingPercentage: 70 },
    { skill: "CSS", ratingPercentage: 70 },
  ];

  const projectsDetails = [
    {
      title: "Personal Portfolio Website",
      duration: { fromDate: "2021", toDate: "2021" },
      description:
        "A Personal Portfolio website to showcase all my details and projects at one place.",
      subHeading: "Technologies Used: React JS, Node Js, Express Js, NodeMailer(email) & Bootsrap",
    },
    {
      title: "ITBoost: Documentation System",
      duration: { fromDate: "2020", toDate: "2021" },
      description:
        "The documentation system (ITBoost.com), which show us a real-time data, with client feedback and password manager features, as well as ticket, asset and monitoring data from your external IT platforms.",
      subHeading:
        "Technologies Used: Mongo DB, Epress Js, React Js, Node JS, Redux/Saga, Stripe payment getway",
    },
    {
      title: "Optimist: Customer Onboarding",
      duration: { fromDate: "2018", toDate: "2020" },
      description:
        "A web application which helps banks to expidiate onboarding of customer for loan, customer can mannually or upload the financial documents to complete the loan process.",
      subHeading:
        "Technologies Used:  React, Mongo DB, Express Js, Node Js, Redux, React Meterial UI, Python",
    },   
    {
      title: "Real-E-State & Dental care application",
      duration: { fromDate: "2016", toDate: "2018" },
      description:
        "Real-E-State & Dental care application to make the peoples life easy by solving living & dental problems.",
      subHeading: "Technologies Used: React JS, Anagular, Material UI, Node Js, Bootsrap",
    },
  ];

  const workDetails = [
    {
      title: "Connectwise India",
      duration: { fromDate: "2020", toDate: "Present" },
      description:
        "Developing the Documentation system,  to show you real-time data, with client feedback and password manager features, as well as ticket, asset and monitoring data from your external IT platforms. ",
      subHeading: "MERN stack developer",
    },
    {
      title: "FIS Solutions India ",
      duration: { fromDate: "2018", toDate: "2020" },
      description:
        "Part of desiging the web application which helps banks to onboarding their customer for loan, customer can mannually or upload the financial documents to complete the loan process.",
      subHeading:
        "MERN stack developer",
    },
    {
      title: "ARD softech",
      duration: { fromDate: "2016", toDate: "2018" },
      description:
        "Part of designing the Real-E-State application and dental care application, it helps users to buy, cell or rent the properties and also can get doctors appointment to take care of teeths.",
      subHeading:
        "Software Developer (Angular/React/Node)",
    },
  ];

  const resumeDetails = [
    <div className="resume-screen-container" key="education">
      <ResumeHeading
        heading={"Shivaji University, Sangali, Maharashtra, India"}
        subHeading={"B.Tech in Computer Engineering"}
        fromDate={"2013"}
        toDate={"2016"}
      />

      <ResumeHeading
        heading={"Maharashtra State Board of Technical Education, Mumbai"}
        subHeading={"Diploma in Computer Engineering"}
        fromDate={"2010"}
        toDate={"2013"}
      />
      <ResumeHeading
        heading={"High School, Latur "}
        subHeading={"Nirmalpuri High School"}
        fromDate={"2005"}
        toDate={"2010"}
      />
    </div>,

    /* WORK EXPERIENCE */
    <div className="resume-screen-container" key="work-experience">
      <div className="experience-container">
        {workDetails.map((workDetail, index) => (
          <ResumeHeading
            key={index}
            heading={workDetail.title}
            subHeading={workDetail.subHeading}
            description={workDetail.description}
            fromDate={workDetail.duration.fromDate}
            toDate={workDetail.duration.toDate}
          />
        ))}
      </div>
    </div>,

    /* PROGRAMMING SKILLS */
    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills"
    >
      {programmingSkillsDetails.map((skill, index) => (
        <div className="skill-parent" key={index}>
          {/* <div className="heading-bullet"></div> */}
          <span>{skill.skill + ` : ${skill.ratingPercentage}%`}</span>
          <div className="skill-percentage">
            <div
              style={{ width: skill.ratingPercentage + "%" }}
              className="active-percentage-bar"
            ></div>
          </div>
        </div>
      ))}
    </div>,

    /* PROJECTS */
    <div className="resume-screen-container" key="projects">
      {projectsDetails.map((projectsDetails, index) => (
        <ResumeHeading
          key={index}
          heading={projectsDetails.title}
          subHeading={projectsDetails.subHeading}
          description={projectsDetails.description}
          fromDate={projectsDetails.duration.fromDate}
          toDate={projectsDetails.duration.toDate}
        />
      ))}
    </div>,

    /* Interests */
    <div className="resume-screen-container" key="interests">
      <ResumeHeading
        heading="Learning new technologies"
        description="I'm tech enthusiast and a code writer. So I love to learn new teachologie and implement in project"
      />
      <ResumeHeading
        heading="Music"
        description="Apart from being a tech enthusiast and a code writer, I like to listen indian classic songs and sometime english songs."
      />
      <ResumeHeading
        heading="Trekking"
        description="I like to go on Trekking, which is typically something that is more challenging, requires more effort and that tends to take more than one day"
      />
      <ResumeHeading
        heading="Movies & Web series"
        description="I do watch hollywood movies and web series with my friends."
      />
      <ResumeHeading
        heading="Fitness"
        description="I always take care of my health, to stay healthy and fit I do exercise and running every day."
      />
    </div>,
  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/resume/${bullet.logoSrc}`).default}
          alt={bullet.label}
        />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      /* UNSUBSCRIBE THE SUBSCRIPTIONS */
      fadeInSubscription.unsubscribe();
    };
  }, [fadeInSubscription]);

  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading title={"Resume"} subHeading={"My formal Bio Details"} />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
